import type { FileType } from '@/types/common';
import { fileTypes } from '@/types/common';

export const getFileExtension = (fileName: string) => {
  return fileName.split('.').pop();
};

export const getFileTypeFromFileUrl = (file: File): FileType => {
  const mime = file.type;

  if (mime.startsWith('image/')) {
    return fileTypes.IMAGE;
  }

  if (mime === 'application/pdf') {
    return fileTypes.PDF;
  }

  if (mime.startsWith('video/')) {
    return fileTypes.VIDEO;
  }

  return fileTypes.UNKNOWN;
};
